import { useState } from 'react';
import {  Dispatch, SetStateAction } from 'react';
export const enum ModalStep {
  SearchBank,
  SelectBank,
  SearchBranch,
  SelectBranch,
}


export type BankStepProps = {
  modalStep : ModalStep;
  setModalStep : Dispatch<SetStateAction<ModalStep>>;
}


const getTitle = (modalStep : ModalStep) : string => {
  switch(modalStep){
    case ModalStep.SearchBank:
      return '';
    case ModalStep.SelectBank:
      return '金融機関の選択';
    case ModalStep.SearchBranch:      
      return '支店名の検索';
    case ModalStep.SelectBranch:      
      return '支店名の選択';

  }
}

const getMessage = (modalStep : ModalStep) : string => {
  switch(modalStep){
    case ModalStep.SearchBank:
      return '';
    case ModalStep.SelectBank:
      return '金融機関名を選択し、「選択する」ボタンを押してください。';
    case ModalStep.SearchBranch:      
      return '金融機関名をご確認いただき、支店名を選択してください。';
    case ModalStep.SelectBranch:      
      return '支店名を選択し、「選択する」ボタンを押してください。';

  }
}

const getBankName = (modalStep : ModalStep, localBankName : string) : string => {
  switch(modalStep){
    case ModalStep.SearchBank:
      return '';
    case ModalStep.SelectBank:
      return '';
    case ModalStep.SearchBranch:      
      return localBankName;
    case ModalStep.SelectBranch:      
      return localBankName;

  }
}

export const useBankSelectionIndex = () => {
  const [bankModalStep, setBankModalStep] = useState<ModalStep>(ModalStep.SearchBank);
  const [bankList, setBankList] = useState<string[]>([]);
  const [branchList, setBranchList] = useState<string[]>([]);
  const [localBankName, setLocalBankName] = useState<string>('');


  const title = getTitle(bankModalStep);

  const message = getMessage(bankModalStep)

  const bankName = getBankName(bankModalStep, localBankName)

  return {
    bankModalStep,
    setBankModalStep,
    bankList,
    setBankList,
    branchList,
    setBranchList,
    bankName,
    setLocalBankName,
    title,
    message
  };
};
